import { platformMyDayHostCapability, platformMyDayHostSlots, } from '@crest/platform-contracts/hosts';
import { projectsProjectDetailHostCapability, projectsProjectDetailHostSlots, } from '../contracts/projects-project-detail-host.contract.js';
import { projectsProjectDetailLauncherCapability } from '../contracts/projects-project-detail-launcher.contract.js';
import { projectsModuleManifest } from '../projects.module.js';
import { projectsSettingRegistrations } from '../settings/projects-setting-definitions.js';
export const projectsWebModuleContribution = {
    moduleId: 'projects',
    manifest: projectsModuleManifest,
    settingRegistrations: projectsSettingRegistrations,
    settingEditors: [
        {
            id: 'projects.web.settings.board-configuration',
            moduleId: 'projects',
            settingKey: 'projects.board.configuration',
            priority: 0,
            load: () => import('./projects-board-configuration-setting-editor.js'),
        },
        {
            id: 'projects.web.settings.board-appearance',
            moduleId: 'projects',
            settingKey: 'projects.board.appearance',
            priority: 10,
            load: () => import('./projects-board-appearance-setting-editor.js'),
        },
        {
            id: 'projects.web.settings.detail-launcher-configuration',
            moduleId: 'projects',
            settingKey: 'projects.detail-launcher.configuration',
            priority: 20,
            load: () => import('./projects-project-detail-launcher-setting-editor.js'),
        },
    ],
    hostContracts: [{
            capability: projectsProjectDetailHostCapability,
            slots: Object.values(projectsProjectDetailHostSlots),
        }],
    launcherContracts: [{ capability: projectsProjectDetailLauncherCapability }],
    hostContributions: [{
            id: 'projects.web.platform.my-day',
            moduleId: 'projects',
            slot: platformMyDayHostSlots.primary,
            contractVersion: platformMyDayHostCapability,
            requiredPermission: 'projects.projects.read',
            settingCondition: null,
            priority: 17,
            errorBehavior: 'inline',
            emptyBehavior: 'collapse',
            load: () => import('./projects-my-day.panel.js'),
        }],
    routes: [
        {
            id: 'projects.web.projects',
            moduleId: 'projects',
            path: '/projects',
            requiredPermission: 'projects.projects.read',
            navigation: {
                id: 'projects.navigation.projects',
                fallbackLabel: 'Projects',
                labelConfigurationKey: 'platform.copy.core',
                labelValueProperty: 'navigationProjects',
                priority: 0,
            },
            load: () => import('./projects-list.page.js'),
        },
        {
            id: 'projects.web.board',
            moduleId: 'projects',
            path: '/projects/board',
            requiredPermission: 'projects.projects.read',
            navigation: {
                id: 'projects.navigation.board',
                fallbackLabel: 'Job Board',
                labelConfigurationKey: 'projects.copy.default',
                labelValueProperty: 'boardNavigationLabel',
                priority: 10,
            },
            load: () => import('./projects-board.page.js'),
        },
        {
            id: 'projects.web.project-detail',
            moduleId: 'projects',
            path: '/projects/:projectId',
            requiredPermission: 'projects.projects.read',
            navigation: null,
            load: () => import('./projects-project-detail.page.js'),
        },
    ],
};
//# sourceMappingURL=projects-web.module-contribution.js.map